export const memberGroupList = [
  {
    name: 'Deal Leader',
    key: 'dls',
    required: true,
    alwaysShow: true,
    idKey: 'dlId',
    id: 1
  },
  {
    name: 'Deal Member',
    key: 'dms',
    alwaysShow: true,
    idKey: 'dmIds',
    id: 2
  },
  {
    name: 'DD Leader',
    key: 'ddLs',
    idKey: 'ddLIds',
    id: 7
  },
  {
    name: 'DD项目组',
    key: 'ddMs',
    idKey: 'ddMIds',
    id: 8
  },
  {
    name: '合作DL',
    key: 'cooperations',
    idKey: 'cooperationDlIds',
    id: 10
  },
  {
    name: '主管合伙人',
    key: 'partners',
    idKey: 'partnerId',
    id: 11
  },
  {
    name: '法务',
    key: 'laws',
    idKey: 'lawIds',
    id: 3
  },
  {
    name: '财务',
    key: 'finances',
    idKey: 'financeIds',
    id: 4
  },
  {
    name: '创服',
    key: 'backs',
    idKey: 'backIds',
    id: 5
  },
  {
    name: '创服BP',
    key: 'bps',
    idKey: 'bpId',
    id: 14
  },
  // {
  //   name: '投后管理负责人',
  //   key: 'aims',
  //   idKey: 'aims',
  //   id: 15
  // },
  {
    name: 'venture运营',
    key: 'operatorVentureIds',
    idKey: 'operatorVentureIds',
    id: 17
  },
  {
    name: '其他',
    key: 'others',
    idKey: 'otherIds',
    id: 9
  }
];

export const nodeMap = {
  0: '用户创建项目',
  1: '发起上会',
  2: '撤销上会',
  3: '发起TS',
  4: 'drop TS',
  5: 'Portfolio再融资',
  6: '保持关注',
  7: '暂不跟进',
  8: '交割',
  9: 'Notes/文档变更'
};

export const secretTypeList = [
  {
    type: 1,
    name: '普通项目'
  },
  {
    type: 2,
    name: '绝密项目'
  },
  {
    type: 3,
    name: '专利项目'
  }
];

export const projectTypeMap = {
  0: '未上会',
  1: '已上会',
  2: 'Portfolio'
};

export const phaseMap = {
  0: '发展期',
  1: '融资期'
};

export const financingStageMap = {
  1: 'Seed',
  2: 'Venture',
  3: 'Growth'
};

export const priorityMap = {
  0: 'P0',
  1: 'P1',
  2: 'P2',
  3: 'P3'
};

export const meetingCategory = [
  {
    value: 1,
    label: 'Seed',
    children: [
      {
        value: 6,
        label: 'Seed'
      }
    ]
  },
  {
    value: 2,
    label: 'Venture',
    children: [
      {
        value: 1,
        label: 'Early'
      },
      {
        value: 2,
        label: 'Early Growth'
      }
    ]
  },
  {
    value: 3,
    label: 'Growth',
    children: [
      {
        value: 3,
        label: 'Growth'
      },
      {
        value: 5,
        label: 'Late Growth'
      }
    ]
  }
];

export const meetingTypeList = [
  {
    value: 1,
    label: 'online'
  },
  {
    value: 2,
    label: 'offline'
  }
];

export const askMeetingTypeMap = {
  1: 'online',
  2: 'offline'
};

export const secretMeetingTypeList = [
  {
    value: 0,
    label: '公开'
  },
  {
    value: 1,
    label: '保密'
  }
];

export const stageGroupMap = {
  1: 2,
  2: 2,
  3: 3,
  5: 3,
  6: 1
};

const templateNameMap = {};
export const meetingTemplateCategory = meetingTypeList.map(type => {
  return {
    value: type.value,
    label: `${type.label}会议`,
    children: meetingCategory.map(_ => {
      templateNameMap[`${type.value}${_.value}`] = `${_.label}项目决策会(${type.label})`;
      return {
        value: _.value,
        label: `${_.label}项目决策会`
      };
    })
  };
});

export { templateNameMap };

export const meetingUploadlist = ['BP', 'InterestingCase', 'OnePager', 'DD Memo', 'BDD', 'LDD', 'FDD', 'IT DD', 'HDD', 'PDD', '其他'];
